import { useMemo, useState, useEffect, useCallback } from "react";
import TableUsuarios from '../Components/TableUsuarios';
import Api from '../Auth/Api';
import Select from 'react-select';
import { Controller, useForm } from "react-hook-form";
import { Badge, Modal, Toast } from 'react-bootstrap';
import { decodeJWT } from "../Components/jwtUtils";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import UsuariosManager from '../Components/Dashboard/Usuarios/UsuariosManager';

function ListaUsuarios() {

    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;

    const [selectedTipo, setSelectedTipo] = useState('favoritos');
    const filterTipo = [
        { value: 'favoritos', label: 'Favoritos' },
        { value: 'todos', label: 'Todos' }
    ]

    const LoadingScreen = () => {
        return (
            <div className="d-flex align-items-center justify-content-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    const [selectedFilter, setSelectedFilter] = useState("Aluno");
    const [showModalEditarUsuario, setShowModalEditarUsuario] = useState(false);
    const [showModalResetSenha, setShowModalResetSenha] = useState({ show: false });
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [selectCursos, setSelectCursos] = useState(false);
    const [showEmpresaEdit, setShowEmpresaEdit] = useState(false);
    const [showGestorResponsavelEdit, setShowGestorResponsavelEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showModalPesquisa, setShowModalPesquisa] = useState({ show: false, data: null });
    const [showModalStatus, setShowModalStatus] = useState({ show: false, id: null, nome: '', status: false });

    const { register, handleSubmit, control, setValue, formState: { errors } } = useForm();

    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [selectedUnidade, setSelectedUnidade] = useState(null);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);

    // Inicializar o UsuariosManager
    const usuariosManager = UsuariosManager({ token, nivel });

    useEffect(() => {
        setLoading(true);
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-usuarios/nivel/${selectedFilter}/${selectedTipo}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    params: {
                        unidade: selectedUnidade ? selectedUnidade.value : undefined,
                        empresa: selectedEmpresa ? selectedEmpresa.value : undefined,
                    }
                });
                setDataUsuarios(response.data);
                setLoading(false);
            } catch (error) {
                console.error(error.response.data.message)
                setLoading(false);
                setDataUsuarios([]);
            }
        }
        fetchData();
    }, [token, selectedFilter, selectedTipo, selectedUnidade, selectedEmpresa, toast, usuariosManager.showModalAddUsuario]);

    const [dataCursos, setDataCursos] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-cursos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataCursos(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token, toast]);

    const [dataUnidades, setDataUnidades] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-unidades`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataUnidades(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token]);

    const [dataEmpresas, setDataEmpresas] = useState([]);
    useEffect(() => {
        async function fetchData() {
            // Gestores não precisam carregar lista de empresas
            if (nivel === 'Gestor') return;
            
            try {
                const response = await Api.get(`api/listar-empresas`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataEmpresas(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token, nivel]);

    const dataNiveis = useMemo(() => {
        const niveis = [
            { value: 'Aluno', label: 'Aluno' },
            { value: 'Gestor', label: 'Gestor' },
            { value: 'Moderador', label: 'Moderador' },
            { value: 'Administrador', label: 'Administrador' },
        ];
        if (nivel === 'Gestor') {
            return niveis.filter(nivel => nivel.value === 'Aluno');
        } else if (nivel === 'Moderador') {
            return niveis.filter(nivel => nivel.value === 'Aluno' || nivel.value === 'Gestor');
        }
        return niveis;
    }, [nivel]);

    const [loadingSave, setLoadingSave] = useState(false);

    const onSubmitEditarUsuario = async (data) => {
        setLoadingSave(true);
        data.cursos = (data.cursos || []).map((curso) => curso.value);
        try {
            const response = await Api.post(`api/editar-usuario/${data.id}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setToast({ header: 'Sucesso!', body: response.data.message })

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message })
            console.error("Erro ao criar nova aula:", error)
        }
        setLoadingSave(false);
        setShowToast(true)
        setShowModalEditarUsuario(false)
    }

    const handleResetPassword = async (id) => {
        try {
            const response = await Api.post(`api/resetar-senha/${id}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setToast({ header: 'Sucesso!', body: response.data.message })
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message })
            console.error("Erro ao resetar senha:", error)
        }
        setShowModalResetSenha({ show: false })
        setShowToast(true)
    };

    const handleFavoritar = useCallback(async (id) => {
        try {
            await Api.post(`api/favoritar/${id}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // Atualiza o estado do usuário na lista
            setDataUsuarios(prevUsers =>
                prevUsers.map(user =>
                    user.id === id ? { ...user, favorito: true } : user
                )
            );
        } catch (error) {
            setToast({ header: 'Ops!', body: "Aconteceu um erro :(" });
            setShowToast(true);
            console.error("Erro ao favoritar usuário:", error);
        }
    }, [token]);

    const handleDesfavoritar = useCallback(async (id) => {
        try {
            await Api.post(`api/desfavoritar/${id}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // Atualiza o estado do usuário na lista
            setDataUsuarios(prevUsers =>
                prevUsers.map(user =>
                    user.id === id ? { ...user, favorito: false } : user
                )
            );
        } catch (error) {
            console.error("Erro ao desfavoritar usuário:", error);
        }
    }, [token]);

    const handleShowPesquisa = useCallback((id) => {
        const usuario = dataUsuarios.find(user => user.id === id);
        if (usuario && usuario.pesquisa_satisfacao) {
            try {
                const pesquisaObj = JSON.parse(usuario.pesquisa_satisfacao);

                // Transformar o objeto de perguntas em um array
                const pesquisaArray = Object.entries(pesquisaObj).map(([key, value]) => ({
                    pergunta: value.pergunta,
                    resposta: value.resposta,
                    data_resposta: new Date().toISOString()
                }));

                setShowModalPesquisa({ show: true, data: pesquisaArray });
            } catch (error) {
                console.error("Erro ao processar dados da pesquisa:", error);
                setToast({ header: 'Ops!', body: "Erro ao processar dados da pesquisa" });
                setShowToast(true);
                setShowModalPesquisa({ show: true, data: [] });
            }
        } else {
            setShowModalPesquisa({ show: true, data: [] });
        }
    }, [dataUsuarios]);

    const [dataCargos, setDataCargos] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/show/cargos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // dataCargos tem que ser um array de objetos com as chaves 'value' e 'label'
                setDataCargos(response.data.map((cargo) => {
                    return {
                        value: cargo.id,
                        label: cargo.nome
                    };
                }
                ));
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token]);

    const [dataGestores, setDataGestores] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/show/gestores`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataGestores(response.data.map((cargo) => {
                    return {
                        value: cargo.id,
                        label: cargo.nome_completo
                    };
                }
                ));
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token]);

    const handleTrocarStatus = async (id) => {
        try {
            const response = await Api.post(`api/trocarStatus/${id}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setToast({ header: 'Sucesso!', body: response.data.message });
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message });
            console.error("Erro ao trocar status:", error);
        }
        setShowModalStatus({ show: false });
        setShowToast(true);
    };

    const columns = useMemo(
        () => [
            {
                Header: () => null,
                id: 'foto',
                accessor: row => row.foto,
                Cell: ({ cell: { value }, row: { original } }) => {
                    return (
                        <div className="d-flex align-items-center">
                            <div className="picture text-white bg-grey" style={{ fontSize: '22px', height: '42px', marginRight: '0px', width: '42px' }}>
                                {value ? <img className="object-fit-cover" src={`${process.env.REACT_APP_API_URL}/fotos/${value}`} alt="Profile" style={{ height: '42px', width: '42px' }} /> : <i className="bi bi-person" />}
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: () => null,
                accessor: row => row.nome_completo,
                id: 'nome_completo',
                Cell: ({ cell: { value }, row: { original } }) => {

                    return (
                        <div className="d-flex align-items-center">
                            <div className="d-flex flex-column">
                                <span className="text-primary fw-semibold">{value}</span>
                                {nivel === 'Administrador' &&
                                    <span className="text-primary fs-7">
                                        Já acessou?
                                        <Badge bg={original.primeiro_login === 2 ? "success" : "danger"} className="ms-1">
                                            {original.primeiro_login === 2 ? "Sim" : "Não"}
                                        </Badge>
                                    </span>
                                }
                                {selectedFilter === 'Aluno' && (
                                    <span className="text-primary fs-7">Gestor Responsável: <span className="fw-bold">{!original.gestor_nome ? 'Não Consta' : original.gestor_nome}</span></span>
                                )}
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: () => null,
                accessor: 'codigo'
            },
            {
                Header: () => null,
                accessor: row => row.nivel,
                id: 'nivel',
                Cell: ({ cell: { value } }) => {
                    return (
                        <div className="d-flex align-items-center">
                            <div className="d-flex flex-column">
                                <span className="text-primary fw-semibold">{value === "Gestor" ? "Gestor" : value}</span>
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: () => null,
                accessor: 'email'
            },
            {
                Header: () => null,
                accessor: 'unidade'
            },
            // Coluna de empresa - será mostrada condicionalmente
            ...(selectedFilter === 'Gestor' || selectedFilter === 'Aluno' ? [{
                Header: () => null,
                accessor: 'empresa_nome',
                Cell: ({ cell: { value } }) => {
                    return (
                        <div className="d-flex align-items-center">
                            <span className="text-primary fw-semibold">{value || 'Não informado'}</span>
                        </div>
                    )
                }
            }] : []),
            {
                Header: () => null,
                id: 'actions',
                accessor: row => row.id,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <>
                        <Tippy content={!original.favorito ? "Favoritar" : "Desfavoritar"}>
                            <button onClick={() => {
                                if (!original.favorito) {
                                    handleFavoritar(original.id);
                                } else {
                                    handleDesfavoritar(original.id);
                                }
                            }} className="btn btn-outline-primary justify-content-center align-items-center rounded px-2 me-2">
                                <i className={`bi ${!original.favorito ? 'bi-star' : 'bi-star-fill'} btn_favoritar`} />
                            </button>
                        </Tippy>

                        <Tippy content="Editar usuário">
                            <button
                                disabled={
                                    (nivel === "Moderador" && original.nivel !== "Aluno" && original.nivel !== "Gestor") ||
                                    (nivel === "Gestor" && original.nivel !== "Aluno") ||
                                    (nivel !== "Administrador" && nivel !== "Moderador" && nivel !== "Gestor")
                                }
                                onClick={() => {
                                    setShowModalEditarUsuario(true);
                                    setValue('nome_completo', original.nome_completo);
                                    setValue('email', original.email);
                                    setValue('id', original.id);
                                    setValue('codigo', original.codigo);

                                    const selectNivel = dataNiveis.find(item => item.label === original.nivel);
                                    setValue('nivel', { value: selectNivel.label, label: selectNivel.label });

                                    // Definir se deve mostrar o campo empresa baseado no nível
                                    if (original.nivel === 'Gestor') {
                                        setShowEmpresaEdit(true);
                                        setSelectCursos(false);
                                        setShowGestorResponsavelEdit(false);
                                    } else if (original.nivel === 'Aluno') {
                                        setShowEmpresaEdit(false);
                                        setSelectCursos(true);
                                        // Sempre mostrar o campo gestor responsável para alunos
                                        setShowGestorResponsavelEdit(true);
                                    } else {
                                        setShowEmpresaEdit(false);
                                        setSelectCursos(false);
                                        setShowGestorResponsavelEdit(false);
                                    }

                                    // Preencher empresa se existir
                                    if (original.empresa_id) {
                                        const selectEmpresa = dataEmpresas.find(item => item.id === original.empresa_id);
                                        if (selectEmpresa) {
                                            setValue('empresa', { value: selectEmpresa.id, label: selectEmpresa.titulo });
                                        }
                                    } else {
                                        setValue('empresa', null);
                                    }

                                    // Sempre manter o gestor responsável original
                                    const selectGestor = dataGestores.find(item => item.value === original.gestor_responsavel);
                                    setValue('gestor_responsavel', { value: selectGestor?.value, label: selectGestor?.label });

                                    const selectCargo = dataCargos.find(item => item.label === original.cargo);
                                    setValue('cargo', { value: selectCargo?.value, label: selectCargo?.label });

                                    const selectUnidade = dataUnidades.find(item => item.nome === original.unidade);
                                    if (selectUnidade && selectUnidade.nome) {
                                        setValue('unidade', { value: selectUnidade.nome, label: selectUnidade.nome });
                                    } else {
                                        setValue('unidade', { value: '', label: '' });
                                    }

                                    let selectedCursos = [];

                                    if (original.permissao_cursos && original.permissao_cursos.trim() !== "") {
                                        try {
                                            const cursosArray = JSON.parse(original.permissao_cursos);
                                            selectedCursos = cursosArray.map(cursoId => {
                                                return dataCursos.find(curso => curso.id === cursoId);
                                            }).filter(Boolean);
                                        } catch (error) {
                                            console.error("Erro ao analisar permissao_cursos:", error);
                                        }
                                    }
                                    const cursosForSelect = selectedCursos.map(curso => ({
                                        value: curso.id,
                                        label: curso.nome
                                    }));
                                    setValue('cursos', cursosForSelect);
                                }} className="btn btn-outline-primary justify-content-center align-items-center rounded px-2 me-2 btn_editar">
                                <i className="bi bi-pencil" />
                            </button>
                        </Tippy>

                        <Tippy content="Resetar senha">
                            <button
                                disabled={
                                    (nivel === "Moderador" && original.nivel !== "Aluno" && original.nivel !== "Gestor") ||
                                    (nivel === "Gestor" && original.nivel !== "Aluno") ||
                                    (nivel !== "Administrador" && nivel !== "Moderador" && nivel !== "Gestor")
                                }
                                onClick={() => { setShowModalResetSenha({ show: true, id: original.id, nome: original.nome_completo }) }}
                                className="btn btn-outline-primary justify-content-center align-items-center rounded px-2 me-2">
                                <i className="bi-key-fill btn_senha" />
                            </button>
                        </Tippy>

                        {(nivel === "Administrador" || nivel === "Moderador") && (
                            <Tippy content="Ver pesquisa de satisfação">
                                <button
                                    onClick={() => handleShowPesquisa(original.id)}
                                    className="btn btn-outline-primary justify-content-center align-items-center rounded px-2 me-2">
                                    <i className="bi bi-clipboard2-pulse-fill btn_pesquisa" />
                                </button>
                            </Tippy>
                        )}

                        {(nivel === "Administrador" || nivel === "Moderador") && (
                            <Tippy content={original.status === "ativo" ? "Desativar usuário" : "Ativar usuário"}>
                                <button
                                    disabled={
                                        (nivel === "Moderador" && original.nivel !== "Aluno" && original.nivel !== "Gestor") ||
                                        (nivel === "Gestor" && original.nivel !== "Aluno") ||
                                        (nivel !== "Administrador" && nivel !== "Moderador" && nivel !== "Gestor")
                                    }
                                    onClick={() => setShowModalStatus({
                                        show: true,
                                        id: original.id,
                                        nome: original.nome_completo,
                                        status: original.status
                                    })}
                                    className="btn btn-outline-primary justify-content-center align-items-center rounded px-2 me-2"
                                >
                                    <i className={`bi ${original.status === "ativo" ? 'bi-toggle2-on' : 'bi-toggle2-off'} btn_status`} />
                                </button>
                            </Tippy>
                        )}
                    </>
                )
            }


        ],
        [setValue, dataUnidades, dataNiveis, dataCursos, dataGestores, dataCargos, dataEmpresas, handleDesfavoritar, handleFavoritar, nivel, handleShowPesquisa, selectedFilter]
    );

    const filterSelect = useMemo(
        () => [
            { value: 'Aluno', label: 'Alunos' },
            { value: 'Gestor', label: 'Gestores' },
            { value: 'Moderador', label: 'Moderador' },
            { value: 'Administrador', label: 'Administradores' }
        ].filter(option => {
            if (nivel === 'Gestor') {
                return option.value === 'Aluno';
            } else if (nivel === 'Moderador') {
                return option.value === 'Aluno' || option.value === 'Gestor';
            } else {
                return true; // Administrador vê tudo
            }
        }),
        [nivel]
    );

    const customStyles = {
        control: (base, state) => ({
            ...base,
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.25rem",
            boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
            borderColor: "#233734",
            "&:hover": {
                borderColor: "#3a6883"
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000',
        }),
        input: (base) => ({
            ...base,
            color: '#adb5bd',
            height: "52px",
            margin: '0px',
            padding: '0px !important',
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
        }),
        option: (base, state) => ({
            ...base,
            color: state.isSelected ? '#3a5a6c' : null,
            backgroundColor: state.isFocused ? '#27485b73' : null,
            "&:active": {
                backgroundColor: "#27485b73"
            },
        }),
    };

    return (
        <>
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header>
                    <strong className="mr-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <div className="fade-in w-100">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <span className="text-primary fs-1">Lista de Usuários</span>
                        <p className="fs-6 mb-0">Consulte os usuários cadatrados, filtre, edite e exclua.</p>
                    </div>
                    {(nivel === 'Administrador' || nivel === 'Moderador' || nivel === 'Gestor') && (
                        <button 
                            type="button" 
                            className="btn btn-primary text-white px-4 py-2"
                            onClick={usuariosManager.openAddUsuarioModal}
                        >
                            <i className="bi bi-plus-circle me-2"></i>
                            Adicionar Usuário
                        </button>
                    )}
                </div>

                <div className={loading ? "" : "d-none"}>
                    <LoadingScreen />
                </div>
                <div className={loading ? "d-none" : ""}>
                    <TableUsuarios
                        columns={columns}
                        data={dataUsuarios}
                        setSelectedFilter={setSelectedFilter}
                        selectedFilter={selectedFilter}
                        filterSelect={filterSelect}
                        filterTipo={filterTipo}
                        setSelectedTipo={setSelectedTipo}
                        selectedTipo={selectedTipo}
                        titulo="Lista de Usuários"
                        unidades={dataUnidades}
                        selectedUnidade={selectedUnidade}
                        setSelectedUnidade={setSelectedUnidade}
                        empresas={nivel === 'Gestor' ? [] : dataEmpresas}
                        selectedEmpresa={nivel === 'Gestor' ? null : selectedEmpresa}
                        setSelectedEmpresa={nivel === 'Gestor' ? null : setSelectedEmpresa}
                    />
                </div>
            </div>

            <Modal size="lg" show={showModalEditarUsuario} onHide={() => setShowModalEditarUsuario(false)}>
                <form onSubmit={handleSubmit(onSubmitEditarUsuario)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-4 text-primary">Editar usuário</span>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="body">
                                        <div className="d-flex">
                                            <div className="d-flex flex-column w-100">
                                                <div className="row mb-3">
                                                    <div className="col-12 col-md-8">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Nome</label>
                                                            <input type="text" {...register("nome_completo", { required: true })} placeholder="Nome do usuário" className="form-control border-primary" />
                                                            {errors.nome_completo && <span className='text-danger fs-7'>Nome completo é obrigatório.</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Matrícula</label>
                                                            <input type="text" {...register("codigo", { required: true })} readOnly={nivel !== "Administrador"} className="form-control border-primary" />
                                                            {errors.codigo && <span className='text-danger fs-7'>Código é obrigatório.</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Email</label>
                                                            <input type="email" {...register("email", { required: true })} placeholder="josedasilva@email.com" className="form-control border-primary" />
                                                            {errors.email && <span className='text-danger fs-7'>Email é obrigatório.</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Cargo</label>
                                                            <Controller
                                                                name="cargo"
                                                                control={control}
                                                                defaultValue={[]}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <Select
                                                                        {...field}
                                                                        options={dataCargos}
                                                                        value={field.value}
                                                                        styles={customStyles}
                                                                        placeholder="Selecione um cargo"
                                                                        noOptionsMessage={() => "Nenhum cargo encontrado."}
                                                                    />
                                                                )}
                                                            />
                                                            {errors.cargo && <span className='text-danger fs-7'>Cargo é obrigatório.</span>}
                                                        </div>
                                                    </div>

                                                    {/* Campo de Gestor Responsável - apenas para Aluno */}
                                                    {showGestorResponsavelEdit && (
                                                        <div className="col-12 col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Gestor Responsável</label>
                                                                <Controller
                                                                    name="gestor_responsavel"
                                                                    control={control}
                                                                    defaultValue={[]}
                                                                    rules={{ required: showGestorResponsavelEdit }}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            {...field}
                                                                            options={dataGestores}
                                                                            value={field.value}
                                                                            styles={customStyles}
                                                                            placeholder="Selecione um gestor"
                                                                            onChange={value => field.onChange(value)}
                                                                            noOptionsMessage={() => "Nenhum gestor encontrado."}
                                                                            isDisabled={nivel === 'Gestor'}
                                                                        />
                                                                    )}
                                                                />
                                                                {errors.gestor_responsavel && <span className='text-danger fs-7'>Gestor é obrigatório.</span>}
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="col-12 col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Unidade</label>
                                                            <Controller
                                                                name="unidade"
                                                                control={control}
                                                                defaultValue={[]}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <Select
                                                                        {...field}
                                                                        options={dataUnidades.map((value) => {
                                                                            return {
                                                                                value: value.nome,
                                                                                label: `${value.nome}`,
                                                                            };
                                                                        })}
                                                                        value={field.value}
                                                                        styles={customStyles}
                                                                        onChange={value => field.onChange(value)}
                                                                        placeholder="Selecione uma unidade"
                                                                        noOptionsMessage={() => "Nenhuma unidade encontrada."}
                                                                    />
                                                                )}
                                                            />
                                                            {errors.unidade && <span className='text-danger fs-7'>Selecione uma unidade.</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Tipo Usuário</label>
                                                            <Controller
                                                                name="nivel"
                                                                control={control}
                                                                defaultValue={[]}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <Select
                                                                        {...field}
                                                                        options={dataNiveis}
                                                                        value={field.value}
                                                                        styles={customStyles}
                                                                        onChange={value => {
                                                                            if (value.label === 'Aluno') {
                                                                                setSelectCursos(true);
                                                                                setShowEmpresaEdit(false);
                                                                                // Sempre mostrar o campo gestor responsável para alunos
                                                                                setShowGestorResponsavelEdit(true);
                                                                            } else if (value.label === 'Gestor') {
                                                                                setSelectCursos(false);
                                                                                setShowEmpresaEdit(true);
                                                                                setShowGestorResponsavelEdit(false);
                                                                            } else {
                                                                                setSelectCursos(false);
                                                                                setShowEmpresaEdit(false);
                                                                                setShowGestorResponsavelEdit(false);
                                                                            }
                                                                            field.onChange(value);
                                                                        }}
                                                                        placeholder="Selecione tipo do usuário"
                                                                    />
                                                                )}
                                                            />
                                                            {errors.nivel && <span className='text-danger fs-7'>Tipo de usuário é obrigatório.</span>}
                                                        </div>
                                                    </div>
                                                    {/* Campo de Empresa - apenas para Gestor */}
                                                    {showEmpresaEdit && (
                                                        <div className="col-12 col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Empresa</label>
                                                                <Controller
                                                                    name="empresa"
                                                                    control={control}
                                                                    defaultValue={null}
                                                                    rules={{ required: showEmpresaEdit }}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            {...field}
                                                                            options={dataEmpresas.map((value) => ({
                                                                                value: value.id,
                                                                                label: value.titulo,
                                                                            }))}
                                                                            value={field.value}
                                                                            styles={customStyles}
                                                                            onChange={value => field.onChange(value)}
                                                                            placeholder="Selecione uma empresa"
                                                                            noOptionsMessage={() => "Nenhuma empresa encontrada."}
                                                                            isClearable
                                                                        />
                                                                    )}
                                                                />
                                                                {errors.empresa && <span className='text-danger fs-7'>Empresa é obrigatória para Gestor.</span>}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {(selectCursos || selectedFilter === 'Aluno') &&
                                                        <div className="col-12 col-md-12">
                                                            <div className="mb-3">
                                                                <label className="form-label text-primary fw-medium">Cursos</label>
                                                                <Controller
                                                                    name="cursos"
                                                                    control={control}
                                                                    defaultValue={[]}
                                                                    rules={{ required: true }}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            {...field}
                                                                            isMulti
                                                                            options={dataCursos.map((value) => {
                                                                                return {
                                                                                    value: value.id,
                                                                                    label: `${value.nome}`,
                                                                                };
                                                                            })}
                                                                            value={field.value}
                                                                            styles={customStyles}
                                                                            onChange={value => field.onChange(value)}
                                                                            noOptionsMessage={() => "Nenhum curso encontrado."}
                                                                            placeholder="Selecione os cursos"
                                                                        />
                                                                    )}
                                                                />
                                                                {errors.cursos && <span className='text-danger fs-7'>Selecione pelo menos um curso.</span>}
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center bg-light">
                        <button
                            type="submit"
                            className="btn btn-primary text-white px-5 py-2"
                            disabled={loadingSave}
                        >
                            {loadingSave ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Salvando...
                                </>
                            ) : (
                                'Salvar'
                            )}
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-primary text-primary px-5 py-2 ms-4"
                            onClick={() => setShowModalEditarUsuario(false)}
                            disabled={loadingSave}
                        >
                            Cancelar
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size='lg' show={showModalResetSenha.show} onHide={() => setShowModalResetSenha({ show: false })}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Resetar senha</span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p>Tem certeza que deseja resetar a senha de <b>{showModalResetSenha.nome}</b>?</p>
                                                    <p>Essa ação ira resetar a senha do usuário para o padrão. Essa ação não podera ser revertida.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center bg-light">
                    <button type="submit" className="btn btn-primary text-white px-5 py-2" onClick={() => handleResetPassword(showModalResetSenha.id)}>Resetar</button>
                    <button type="button" className="btn btn-outline-primary text-primary px-5 py-2" onClick={() => setShowModalResetSenha({ show: false })}>Cancelar</button>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalPesquisa.show} onHide={() => setShowModalPesquisa({ show: false, data: null })}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Resultado da Pesquisa de Satisfação</span>
                </Modal.Header>
                <Modal.Body>
                    {showModalPesquisa.data ? (
                        <div className="container">
                            {showModalPesquisa.data.length === 0 && (
                                <p className="text-center text-muted">Este usuário ainda não respondeu à pesquisa de satisfação.</p>
                            )}
                            {showModalPesquisa.data.length > 0 && (
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Pergunta</th>
                                                <th>Resposta</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {showModalPesquisa.data.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-primary">{item.pergunta}</td>
                                                    <td>{item.resposta}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <button className="btn btn-outline-primary" onClick={() => setShowModalPesquisa({ show: false, data: null })}>
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal size='lg' show={showModalStatus.show} onHide={() => setShowModalStatus({ show: false })}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">
                        {showModalStatus.status === "ativo" ? 'Desativar' : 'Ativar'} Usuário
                    </span>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <p>Tem certeza que deseja {showModalStatus.status ? 'desativar' : 'ativar'} o usuário <b>{showModalStatus.nome}</b>?</p>
                                <p>O usuário {showModalStatus.status ? 'não' : ''} poderá acessar o sistema após esta ação.</p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center bg-light">
                    <button
                        type="button"
                        className="btn btn-primary text-white px-5 py-2"
                        onClick={() => handleTrocarStatus(showModalStatus.id)}
                    >
                        Confirmar
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-primary text-primary px-5 py-2"
                        onClick={() => setShowModalStatus({ show: false })}
                    >
                        Cancelar
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Adicionar Usuário */}
            {usuariosManager.renderModal(dataCursos)}
        </>
    )
}

export default ListaUsuarios;